<template>
  <input
    class="c-input__item"
    :type="type"
    :name="name"
    :value="value"
    :placeholder="placeholder"
  />
</template>

<script>
export default {
  props: {
    type: String,
    name: String,
    value: String,
    placeholder: String,
  },
}
</script>
